import { render } from "./DivSubsection.vue?vue&type=template&id=7749829e&ts=true"
import script from "./DivSubsection.vue?vue&type=script&lang=ts"
export * from "./DivSubsection.vue?vue&type=script&lang=ts"

import "./DivSubsection.vue?vue&type=style&index=0&id=7749829e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__